/**
 * Set REACT_APP_STRIPE_ENABLED=true in .env when Stripe keys are configured.
 * Until then, online card payment entry points show a “Coming soon” experience
 * while manual flows (mark paid, upgrade via admin, etc.) stay available.
 */
export const isStripePaymentsLive = () =>
  process.env.REACT_APP_STRIPE_ENABLED === 'true';

/** Use test dashboard URLs when using Stripe test keys (REACT_APP_STRIPE_TEST_MODE=true). */
export const stripeDashboardBase = () =>
  process.env.REACT_APP_STRIPE_TEST_MODE === 'true'
    ? 'https://dashboard.stripe.com/test'
    : 'https://dashboard.stripe.com';

export const stripeProductDashboardUrl = (productId) =>
  productId ? `${stripeDashboardBase()}/products/${encodeURIComponent(productId)}` : '';

export const stripePriceDashboardUrl = (priceId) =>
  priceId ? `${stripeDashboardBase()}/prices/${encodeURIComponent(priceId)}` : '';
